<template>
  <div id="AppVersionsAdd">
      <v-layout wrap row mb-1>
      <v-flex md6 pb-4 style="min-height:70px;">
        <v-btn fab left to="/AppVersion" class="ml-3 pf-btn-fab">
          <v-icon>arrow_back</v-icon>
        </v-btn>
         </v-flex>
        <v-flex offset-md1 md5 v-if="selectedData">
        <div style="float:right">
          <v-btn class="pf-btn pf-btn-cancel" to="/AppVersion">
            <v-icon size="16" class="pr-1">cancel</v-icon>
            <div>Cancel</div>
          </v-btn>
          <v-btn class="pf-btn pf-btn-save" @click="save">
            <v-icon size="16" class="pr-1">check_circle</v-icon>
            <div>Save</div>
          </v-btn>
        </div>
      </v-flex>
    </v-layout>
    <v-form ref="appVersionAdd">
      <v-container>
        <v-layout>
          <v-flex class="xs12 sm6 md7">
            <v-text-field label="Android Version" :rules="[rules.required, rules.versionFormat]" v-model.trim="appVersion.android_version" class="required pr-4 pl-4" @input="changedData" required></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout>
            <v-flex class="xs12 sm6 md7">
            <v-text-field label="IOS Version" :rules="[rules.required, rules.versionFormat]" v-model.trim="appVersion.ios_version" class="required pr-4 pl-4" @input="changedData" required></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
      <v-layout class="editor-button-container">
        <v-flex xs12 class="button-container text-xs-right" v-if="selectedData">
          <div class="d-inline-flex">
            <v-btn class="pf-btn pf-btn-cancel" to="/AppVersion">
              <v-icon size="16" class="pr-1">cancel</v-icon>
              <div>Cancel</div>
            </v-btn>
            <v-btn class="pf-btn pf-btn-save" @click="save">
              <v-icon size="16" class="pr-1">check_circle</v-icon>
              <div>Save</div>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
  </div>
</template>

<script>
/* global session store */
import { create, getCollection } from '../../helpers/helpers';
import swal from 'sweetalert2';
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default {
  data: () => ({
    selectedData: false,
    appVersion: {
      'ios_version': '',
      'android_version': ''
    },
    rules: {
      required: value => !!value || 'Version is required.',
      versionFormat: (v) => /(\d+\.)(\d+\.)(\d)/.test(v) || 'Please enter valid version'
    }
  }),
  computed: {
    appVersionList: {
      get () {
        return store.state.appVersionList;
      },
      set (value) {
        store.commit('setAppVersionList', value);
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  created () {
    this.getAppVersionList();
  },
  mounted () {
    window.getApp.$emit('pageSubHeader', 'Add');
  },
  methods: {
    async getAppVersionList () {
      if (!this.appVersionList.length) {
        let entity = `AppVersion`;
        let { error, data } = await getCollection(entity, true);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.appVersionList = data;
          }
        }
      }
    },
    async save () {
      if (this.$refs.appVersionAdd.validate()) {
        this.selectedData = false;
        let newAppVersion = { ...this.appVersion };
        let { error, data, status } = await create('AppVersion', newAppVersion);
        if (error) {
          this.selectedData = true;
          console.log('error', error);
        } else {
          this.appVersionList.push(data);
          swal.fire({
            type: 'success',
            title: 'App Version added successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.$router.push({ path: '/AppVersion' });
            }
          });
        }
      }
    },
    changedData () {
      this.selectedData = true;
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/AppVersion/add.vue